import api from "@/api/axios.js";
const state = {
  locale: "zh",
  userBase: {
    openId: "",
    nickname: "",
    sex: "",
    province: "",
    city: "",
    country: "",
    headimgurl: "",
    privilege: [],
    unionid: "",
    userId: "",
    displayname: "",
    displaynameEn: "",
    email: "",
    status: "",
    uuid: "",
    phone: "",
    type: "",
    memberCenterId: ""
  },
  islogin: false, //用户数据是否加载完成
  channelId: "", //当前选择的门店id
  channelIds: "", //当前账号所有门店id
  channelList: [],
  userPermission: {
    service: ["permtest001"]
  }
};

let userResolve = function() {
  return false;
};
const userIsLogin = new Promise(function(resolve, reject) {
  userResolve = resolve;
});

// getters
const getters = {
  getUserInfoLocale: (state, getters, rootState) => {
    return state.locale;
  },
  getChannelList: (state, getters, rootState) => {
    return state.channelList;
  },
  getChannelId: (state, getters, rootState) => {
    return state.channelId;
  },
  getChannelIds: (state, getters, rootState) => {
    return state.channelIds;
  },
  getIslogin: (state, getters, rootState) => {
    return state.islogin;
  },
  getIsloginPromise: (state, getters, rootState) => {
    return userIsLogin;
  }
};

// actions
const actions = {
  getApiUserInfoLocale({ state, commit }, product) {
    commit("locale", null);
  },
  getUserPermission({ state, commit }, product) {
    api.post({
      sc: "permission",
      url: "userManage/listUserRoleProgram/" + state.userBase.uuid,
      success: function(r) {
        let list = r.result || [];
        let pList = [];
        if (list.length > 0) {
          list.filter(item => pList.push(item.rpCode));
        }
        commit("setUserPermission", { service: pList });
      }
    });
  }
};

// mutations
const mutations = {
  setUserInfoLocale(state, locale) {
    state.locale = locale;
  },
  setUserInfoUserBase(state, data) {
    if (data) {
      data = data[0] || data;
      Object.assign(state.userBase, data);
    }
  },
  setUserPermission(state, data) {
    state.userPermission = data;
  },
  //设置当前选择的id
  setChannelId(state, data) {
    state.channelId = data;
  },
  setIslogin(state, data) {
    if (data == true) {
      userResolve(true);
    }
    state.islogin = data;
  },
  //设置用户店铺
  setUserChannel(state, dataList) {
    state.channelList = dataList;
    let channelIdList = [];
    dataList.filter(item => {
      channelIdList.push(item.id);
    });
    //som首页查询分类使用的是多个id逗号分隔
    state.channelIds = channelIdList.join();
    //设置当前选择的门店id。默认选第一个
    state.channelId = channelIdList[0];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js